import React, { useState, useEffect } from 'react';
import { Wifi, WifiOff, RefreshCw } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

export const NetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showReconnected, setShowReconnected] = useState(false);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const goOnline = () => {
      setIsOnline(true);
      if (wasOffline) {
        setShowReconnected(true);
        setTimeout(() => setShowReconnected(false), 3000);
      }
    };
    const goOffline = () => {
      setIsOnline(false);
      setWasOffline(true);
    };
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, [wasOffline]);

  return (
    <AnimatePresence>
      {!isOnline && (
        <motion.div
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -50, opacity: 0 }}
          className="fixed top-0 left-0 right-0 z-[100] bg-orange-500 text-black text-center py-2 px-4 text-sm font-medium flex items-center justify-center gap-2"
          data-testid="offline-banner"
        >
          <WifiOff className="w-4 h-4" />
          Sem conexão — exibindo dados salvos
        </motion.div>
      )}
      {showReconnected && isOnline && (
        <motion.div
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -50, opacity: 0 }}
          className="fixed top-0 left-0 right-0 z-[100] bg-neon-lime text-black text-center py-2 px-4 text-sm font-medium flex items-center justify-center gap-2"
          data-testid="reconnected-banner"
        >
          <Wifi className="w-4 h-4" />
          Conexão restaurada — sincronizando...
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export const StaleIndicator = ({ isStale }) => {
  if (!isStale) return null;
  return (
    <div className="flex items-center gap-1.5 text-xs text-zinc-500 mb-2" data-testid="stale-indicator">
      <RefreshCw className="w-3 h-3 animate-spin" />
      Atualizando...
    </div>
  );
};
